import React, { Component, useMemo } from "react";
import { connect } from "react-redux";
import Seatchart from "../seatchart/seatchart";
import Trackbus from "../trackbus/trackbus";
import Showpath from "../showpath/showpath";
import store from "../../store";
import { color, apiUrl } from "../common/constants";
import { getImgPath } from "../common/helper";
import WaitList from "./waitList";
import moment from "moment";
import { getRevDate } from "../common/helper";
import { amens, covidAmens, ShieldNoBorder, SRPTripIcon } from "../common/icons/svg";
import {
  updateSeatChart,
  updateSeatChartDet,
  updateFilterReset,
  updateLoader,
  updateTripDetail,
  updatePathDtls,
  updateRouteCodeDtls,
  updateBusServiceType,
  updateTripCode,
  updateCheckoutDet,
  updateFilterBusService,
  updateFilterBoardingPoint,
  updateFilterDroppingPoint,
  updateShowpassenger,
  updateBusImage,
} from "../../actions/search-actions";
import {
  getDur,
  getFormattedTime,
  getFormattedDayDate,
  getPointTime,
  fetchGet,
  get24HoursTime,
  getDateFormatted2,
  get24HoursDateTime,
  isTripStarted,
} from "../../common/common";
// import SliderScroll from "../common/slider";
import ImageSlider from "../common/imgSlider";
import ServiceRouteDtls from "../common/serviceRouteDtls";
import { renderImg } from "../common/icons/img";
import { AMENITIES, AVAILABLE, BEFORE, BOARDING_POINTS, BUS_PICTURES, CANCELLATION_POLICY, CANC_CHGS, CLOSE_CHART, DROPPING_POINTS, DURATION, EXT_OFF_RND_TP, HRS, NON_RFNDBLE, NON_RSRVBLE, NO_RESLTS_FND, REACHES_ON, REMOVE_FILTER, RND_TP_DISC, SAFE_BUS, SELECT_BERTH, SELECT_SEATS, SOLD_OUT, SPL_B, STARTS_AT, TM_BFR_TP_STRT, TP_STRTS_FRM, VIA, VIA_CITIES, WITHIN, t } from "../../translations/Search";
import { tCommon, RESULT_NOT_FOUND, TO, PLEASE_MODIFY_SEARCH,OR, ADVANCE_BOOKING,CONNECT_BUS_OPTION } from "../../translations/Common";
const repetitions = 10; //repetitions
const delay = 10; //milliseconds
let delayCounter = 0;
let tempScroll, currScrollPos, prevScrollTop;
const imgarray = [
  {
    image: "https://microsites-websitebuilder.s3.amazonaws.com/images/gosuperbus.com-mobile_slider-0-1575545536.jpg",
    alttag: "",
  },
  {
    image: "https://microsites-websitebuilder.s3.amazonaws.com/images/gosuperbus.com-mobile_slider-1-1575545536.jpg",
    alttag: "",
  },
  {
    image: "https://microsites-websitebuilder.s3.amazonaws.com/images/gosuperbus.com-mobile_slider-0-1575545536.jpg",
    alttag: "",
  },
  {
    image: "https://microsites-websitebuilder.s3.amazonaws.com/images/gosuperbus.com-mobile_slider-2-1575545536.jpg",
    alttag: "",
  },
  {
    image: "https://microsites-websitebuilder.s3.amazonaws.com/images/gosuperbus.com-mobile_slider-0-1575545536.jpg",
    alttag: "",
  },
  {
    image: "https://microsites-websitebuilder.s3.amazonaws.com/images/gosuperbus.com-mobile_slider-2-1575545536.jpg",
    alttag: "",
  },
];
// const BusImgArr = [<BusImgLast />, <BusImgFirst />];
// const GajarajImgArr = [<GajrajFirst />, <GajrajLast />];
// const GarudaImgArr = [<GarudaFirst />, <GarudaLast />];
// const DeluxeImgArr = [<DeluxeFirst />, <DeluxeLast />];
// const SwiftAirImgArr = [<SwiftAirFirst />, <SwiftAirLast />]

class ReturnListing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoad: true,
      showDet: {},
      seoChartactive: false,
      showImgSlider: false,
      showImgSliderId: "",
      showrouteDtlsId: "",
      showServiceDtls: false,
      linkfromstoptocity:
        this.props.search.searchParams.linkfromstoptocity,
      fromCity: this.props.search.searchParams.toCity.split("|")[1],
      toCity: this.props.search.searchParams.fromCity.split("|")[1],
      busSeriveType: [],
      summaryPkpDrop: {},
      showPathDet: {},
      showPathId: "",
      buses: [],
      showErrMsg: false,
      showLoader: {},
      showTripLoader: {},
      isSingleLady: this.props.search.searchParams.IsSingleLady == 1 ? true : false,
      isAdvanceBooking: false,
    };
  }

  componentDidMount() {
    let stNo = window.location.search;
    stNo =
      stNo.split("&rsid=").length > 1
        ? stNo.split("&rsid=")[1].split("&")[0]
        : false;
    const stParams = stNo ? true : false;
    stNo && this.setState({ seoChartactive: true });
    store.dispatch(updateSeatChart(stNo, stParams));
    if (stNo) {
      const url =
        window.cdnUrl + "/api/resource/getRouteInfo?routeID=" + stNo;
      fetchGet(url)
        .then((data) => {
          store.dispatch(updateSeatChartDet(stNo, data));
        })
        .catch((err) => console.log(err));
    }
    window.addEventListener("click", (e) => {
      if (this.refs.tooltip) {
        if (
          !(
            e.target.className === "list-pick" ||
            e.target.parentNode.className === "list-pick" ||
            e.target.parentNode.parentNode.className === "list-pick"
          )
        ) {
          this.setState({ showDet: {} });
        }
      }
    });
    if (this.props.search.searchParams.token) {
      setTimeout(() => {
        let that = this;
        that.setState({ showErrMsg: true });
      }, 1800);
    }

    var departDate = getRevDate(this.props.search.searchParams.departDate)
    var departTime = new Date(departDate);
    departTime = departTime.getTime();
    var maxDate = new Date(window.today);
    maxDate.setDate(new Date(maxDate.getDate() + (window.daysForCalendar - 1)));
    var maxTime = maxDate.getTime();
    if (departTime > maxTime) {
      //console.log('advance search');
      this.setState({ isAdvanceBooking: true });
    } else {
      //console.log('within limit');
      this.setState({ isAdvanceBooking: false });
    }
  }

  showTiptxt = (amen) => {
    if (amen === "Filteration") {
      return (
        <span>
          <span className="tooltiptext">
            {amen}:{" "}
            <span
              style={{
                color: "#444",
                fontWeight: "400",
                fontSize: "14px",
              }}
            >
              N95 filters have been installed to prevent the Virus{" "}
              <br /> from circulating in the A/C system
            </span>
          </span>
        </span>
      );
    } else if (amen === "Bipolar Ionisation") {
      return (
        <span>
          <span className="tooltiptext">
            {amen}:{" "}
            <span
              style={{
                color: "#444",
                fontWeight: "400",
                fontSize: "14px",
              }}
            >
              Air purification in the A/c system for safe travel
            </span>
          </span>
        </span>
      );
    } else if (amen === "Fumigation") {
      return (
        <span>
          <span className="tooltiptext">
            {amen}:{" "}
            <span
              style={{
                color: "#444",
                fontWeight: "400",
                fontSize: "14px",
              }}
            >
              using a non toxic and eco friendly disinfectant{" "}
              <br /> to make the vehicle Safe and Sterile
            </span>
          </span>
        </span>
      );
    } else {
      return (
        <span>
          <span className="tooltiptext">{amen}</span>
        </span>
      );
    }
  };

  showAmenities = (val) => {
    // val = "novel,reading light";
    val = val && val.length > 0 ? val.split(",") : [];
    if (val.length > 0) {
      return val.map((amen, index) => {
        var amenity = amen;
        return (
          <div className="" style={{ display: 'flex', marginRight: '20px', lineHeight: '3', width: '20%' }} key={index}>
            {/* {amens({ amen: amen.toLowerCase().split(" ").join("-") })} */}
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {renderImg(amen.toLowerCase().split(" ").join("-"))}  <span className="" style={{ marginLeft: '10px' }}>{amenity}</span>
            </div>
          </div>
        );
      });
    } else {
      return 'Amenities not Present.'
    }
  };

  getCovidImg = (amen) => {
    switch (amen.toLowerCase()) {
      case "covid":
        return "badge-grey-boarder";
      case "hand sanitizer":
        return "hand-sanitizer";
      case "fever check":
      case "thermal screening":
        return "fever-check";
      case "bus sanitization":
        return "bus-sanitization";
      case "bus crew mask":
        return "bus-crew-with-mask";
      case "social distancing":
        return "social-distance";
      case "passenger face mask":
        return "face-mask";
      case "bus crew covid tested":
        return "driver-test";
      default:
        return "badge-grey-boarder";
    }
  };

  showCovidAmenities = (isCovid, val) => {
    val = val && val.length > 0 ? val.split(",") : [];
    if (isCovid) {
      return (
        <div className="covidamens" style={{ marginLeft: "10px" }}>
          <div className="tooltip" style={{ marginRight: 10 }}>
            <ShieldNoBorder />
            <span className="tooltiptext">Covid Safe</span>
          </div>
          {val.map((amen, index) => {
            return (
              <div
                className="tooltip"
                style={{ marginRight: 10 }}
                key={index}
              >
                {/* {covidAmens({ amen: amen })} */}
                {renderImg(amen)}
                {/* <span className="tooltiptext">{amen}</span> */}
                {this.showTiptxt(amen)}
              </div>
            );
          })}
        </div>
      );
    }
  };

  showDiscount = (val) => {
    // if (val.DiscountAmt > 0) {
    //   return (
    //     <div
    //       className="pricetag"
    //       style={{
    //         visibility:
    //           val.AvailableSeats > 0 ? "visible" : "hidden",
    //       }}
    //     >
    //       <span style={{ fontFamily: "sans-serif" }}>
    //         {this.props.search.currency}
    //       </span>
    //       {val.Fare - val.DiscountAmt}
    //     </div>
    //   );
    // }
    // if (val.DiscountPer > 0) {
    //   return (
    //     <div
    //       className="pricetag"
    //       style={{
    //         visibility:
    //           val.AvailableSeats > 0 ? "visible" : "hidden",
    //       }}
    //     >
    //       <span style={{ fontFamily: "sans-serif" }}>
    //         {this.props.search.currency}
    //       </span>
    //       {Math.round(val.Fare - (val.Fare * val.DiscountPer) / 100)}
    //     </div>
    //   );
    // }
    return (
      <div
        // className="pricetag"
        style={{
          /* visibility: val.AvailableSeats > 0 ? "visible" : "hidden", */
          fontSize: '1.25em', fontWeight: '700', color: '#202020',position:'relative'
        }}
      >
        {val.SlackPer > 0 && <div className="discount-tag">{val.SlackPer}% OFF</div>}
        {(val.SlackPer > 0 && val.BasicBeforeWithLevies > 0)&& 
           <span style={{ fontFamily: "sans-serif", paddingRight: '5px',fontWeight:'500',fontSize:'.875em',color:'#666' }}>
           <span style = {{fontWeight:'500',fontSize:'.875em',color:'#666'}}>{this.props.search.currency}<strike>{val.BasicBeforeWithLevies}</strike></span>
         </span>
        }
        <span style={{ fontFamily: "sans-serif", paddingRight: '5px' }}>
          {this.props.search.currency}
        </span>
        {val.Fare}
      </div>
    );
  };

  showSeatchart = (val) => {
    // console.log(this.props.search);
    if (this.state.showDet?.[val.RouteScheduleId]) {
      // console.log(this.state.showDet);
      // console.log(this.props.search.stChrtOthrDtls[val.RouteScheduleId]);

      switch (this.state.showDet[val.RouteScheduleId]) {
        case 1:
          return this.showPolicy(val.RouteScheduleId);
        case 2:
          return this.showPick(val.RouteScheduleId);
        case 3:
          return this.showDrop(val.RouteScheduleId);
        case 4:
          return (
            <div className="seatchart" style={{ paddingTop: 25, fontSize: '0.875em' }}>
              <Showpath routeCode={val.RouteScheduleId} />
            </div>
          );

        case 5:
          return (
            <div className="seatchart" style={{ paddingTop: 25, fontSize: '0.875em' }}>
              <div style={{ display: 'flex', flexWrap: 'wrap' }}> {this.showAmenities(val.AmenitiesType)} </div>
            </div>
          );

        case 6:
          return (
            <div className="seatchart" style={{ paddingTop: 25, fontSize: '0.875em' }}>
              {this.props.search.busImgDtls[val.RouteScheduleId] && this.props.search.busImgDtls[val.RouteScheduleId].length > 0 ?
                <ImageSlider
                  handleSlider={this.handleSlider}
                  img={this.props.search.busImgDtls[val.RouteScheduleId]}
                />
                :
                <div className="seatchart" style={{ paddingTop: 25 }}>
                  No Bus Image Found
                </div>
              }
            </div>
          );


        default:
          return (
            <div className="seatchart" style={{ paddingTop: 25 }}>
              No data found
            </div>
          );
      }
    } else {
      if (this.props.search.stChrtStatus[val.RouteScheduleId]) {
        return (
          <Seatchart
            seat={val}
            DefaultCurrencyID={val.DefaultCurrencyID}
            close={this.closeSeatchart}
            seoChartactive={this.state.seoChartactive}
            isSingleLady={this.state.isSingleLady}
          />
        );
      }
    }
  };

  calHour = (hour) => {
    let h = hour.split("days");
    // console.log("h[0]", h[0]);
    if (h[0].includes("hrs") === false) {
      return `${parseInt(h[0]) * 24} ${t(HRS)}`;
    } else {
      return hour.toUpperCase();
    }
  };

  showTripStart = (rsid) => {
    const pickupdrop = this.props.search.tripDetails[rsid];
    if (
      pickupdrop &&
      pickupdrop.PickupTimings &&
      pickupdrop.PickupTimings.length > 0
    ) {
      let pickdrop = pickupdrop.PickupTimings;
      let pickups = pickdrop.sort(
        (a, b) => new Date(a.PickupTime) - new Date(b.PickupTime)
      );

      if (pickups) {
        return pickups.map((pickup, index) => {
          if (index == 0) {
            return (
              <React.Fragment>
                <div>
                  <div>
                    {t(TP_STRTS_FRM)}
                    {pickup.CityName} on{" "}
                    {get24HoursDateTime(pickup.PickupTime)}
                  </div>
                  <hr
                    style={{
                      border: "1px solid #ddd",
                      width: "100%",
                    }}
                  />
                </div>
                {/* <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  {* <div>{t(TM_BFR_TP_STRT)}</div> *}
                  <div>{'Time Before Departure'}</div>
                  <div>{t(CANC_CHGS)}</div>
                </div> */}
              </React.Fragment>
            );
          }
        });
      }
      // else {
      //   return (
      //     ""
      //   )
      // };
    } else {
      return "";
    }
  };

  parseInHours = (loop) => {
    const canclDtl = Object.keys(loop).map((el, index) => ({
      Canctime: this.calHour(loop[el]),
      Cancpercent: el,
    }));
    return canclDtl;
  };

  showPolicy = (rsid) => {
    if (this.state.showDet[rsid] === 1) {
      /* let loop = this.props.search.stChrtOthrDtls[rsid]
        ? this.props.search.stChrtOthrDtls[rsid].cnclDetails
        : false;
      loop = this.parseInHours(loop);
      if (loop && !!loop.length && loop[0].Canctime.includes("NaN")) {
        loop = false;
      }
      if (loop) { */
      return (
        <div className="seatchart" style={{ paddingTop: 25, fontSize: '0.875em' }}>
          <div style={{ width: "100%" }}>
            {this.showTripStart(rsid)}
            {/* <div>
                {loop.map((el, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        margin: "5px 0",
                      }}
                    >
                      {index === 0 && (
                        <React.Fragment>
                          <div>{`${t(WITHIN)} ${el.Canctime}`}</div>
                          <div>{el.Cancpercent}</div>
                        </React.Fragment>
                      )}

                      {index > 0 &&
                        index < loop.length - 1 && (
                          <React.Fragment>
                            <div>
                              {
                                loop[index - 1]
                                  .Canctime
                              }{" "}
                              to{" "}
                              {
                                loop[index]
                                  .Canctime
                              }
                            </div>
                            <div>
                              {el.Cancpercent}
                            </div>
                          </React.Fragment>
                        )}

                      {index === loop.length - 1 && (
                        <React.Fragment>
                          <div>
                            {t(BEFORE)}{" "}
                            {
                              loop[index - 1]
                                .Canctime
                            }
                          </div>
                          <div>{el.Cancpercent}</div>
                        </React.Fragment>
                      )}
                    </div>
                  );
                })}
                {/* <div>
                {loop && loop.length > 0 && 
                <div>{`Before ${loop[loop.length - 1].Canctime}`}</div>}
                <div>{0}</div>
              </div> 
              </div> */}
            <div className="cancellation-slabs">
              <div className="cancel-slab">
                <div className="col1 bold">Duration (Cancellation time)</div>
                <div className="col2 bold">Cancellation Fee</div>
                <div className="col3 bold">Remarks</div>
              </div>
              <hr
                style={{
                  border: "1px solid #ddd",
                  width: "100%",
                }}
              />
              <div className="cancel-slab">
                <div className="col1">Up to 72 hours before the departure time</div>
                <div className="col2">10% of basic fare + Reservation fee</div>
                <div className="col3">&nbsp;</div>
              </div>
              <div className="cancel-slab">
                <div className="col1">Between 72 hours and up to 24 hours before departure time</div>
                <div className="col2">25% of basic fare + Reservation fee</div>
                <div className="col3">&nbsp;</div>
              </div>
              <div className="cancel-slab">
                <div className="col1">Between 24 hours and up to 2 hours before departure time</div>
                <div className="col2">50% of basic fare + Reservation fee</div>
                <div className="col3">&nbsp;</div>
              </div>
              <div className="cancel-slab">
                <div className="col1">Less then 2 hours before departure time and at/after the departure time</div>
                <div className="col2">100% of basic fare + Other fee</div>
                <div className="col3">NO REFUND</div>
              </div>
            </div>
          </div>
        </div>
      );
      /* } else {
        return (
          <div className="seatchart" style={{ paddingTop: 25 }}>
            Loading...
          </div>
        );
      } */
    }
  };

  showPick = (rsid) => {
    if (this.state.showDet[rsid] === 2) {
      var loop = this.props.search.stChrtOthrDtls[rsid]
        ? this.props.search.stChrtOthrDtls[rsid].pickups
        : false;
      const urlParams = new URLSearchParams(window.location.search);
      // const linkroutecheck = urlParams.get("link");
      const linkfromCityId = urlParams.get("linkfromCity");
      // const stationInFromCityId = urlParams.get("stationInFromCity");
      var pickuplistnew = [];
      if (linkfromCityId) {
        // var toSearch = "Amaravati";
        if (loop !== undefined) {
          var key;
          for (key in loop) {
            if (
              loop[key].PickupLinkCityId ===
              parseInt(linkfromCityId)
            ) {
              pickuplistnew.push(loop[key]);
            }
          }
        }
      }

      if (pickuplistnew.length) {
        loop = pickuplistnew;
      }

      if (loop) {
        return (
          <div className="seatchart" style={{ paddingTop: 25, fontSize: '0.875em' }}>
            <div>
              {loop.map((el, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      margin: "5px 0",
                    }}
                  >
                    <div style={{ width: 400 }}>
                      {el.PickupName}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: 10,
                      }}
                    >
                      {/* <Clock /> */}
                      {renderImg("clock")}
                      {get24HoursTime(el.PickupTime)}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      } else {
        {/*
        return (
           <div ref="tooltip" className="list-pick">
            Loading...
          </div> 
        );*/}
        return null;
      }
    }
  };

  showDrop = (rsid) => {
    if (this.state.showDet[rsid] === 3) {
      var loop = this.props.search.stChrtOthrDtls[rsid]
        ? this.props.search.stChrtOthrDtls[rsid].dropPoints
        : false;
      const urlParams = new URLSearchParams(window.location.search);
      //const linkroutecheck = urlParams.get("link");
      const linktoCityId = urlParams.get("linktoCity");
      // const stationInToCityId = urlParams.get("stationInToCity");
      var dropofflistnew = [];
      if (linktoCityId) {
        // var toSearch = "amaravati";
        if (loop !== undefined) {
          var key;
          for (key in loop) {
            if (
              loop[key].DropLinkCityID === parseInt(linktoCityId)
            ) {
              dropofflistnew.push(loop[key]);
            }
          }
        }
      }
      
      if (dropofflistnew.length) {
        loop = dropofflistnew;
      }

      if (loop) {
        return (
          <div className="seatchart" style={{ paddingTop: 25, fontSize: '0.875em' }}>
            <div>
              {loop.map((el, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      margin: "5px 0",
                    }}
                  >
                    <div style={{ width: 400 }}>
                      {el.DropoffName}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: 10,
                      }}
                    >
                      {/* <Clock /> */}
                      {renderImg("clock")}
                      {get24HoursTime(el.DropoffTime)}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      } else {
        return null;
        /* return (
          <div
            ref="tooltip"
            className="list-pick"
            style={{
              top: "-20px",
            }}
          >
            Loading...
          </div>
        ); */
      }
    }
  };

  openSeatchart = (e, rsid, el, dropofflistnew) => {
    let tripData = { onward: {}, return: {} };
    let showPassenger = this.props.search.showPassenger;
    store.dispatch(updateCheckoutDet([]))
    for (let key in showPassenger) {
      showPassenger[key] = false;
    }
    store.dispatch(updateShowpassenger(showPassenger))
    this.setState({ showDet: {} });
    const card = e.target.parentNode.parentNode;
    currScrollPos = card.getBoundingClientRect().top;
    prevScrollTop = window.scrollY;
    this.animateSeat();
    let addTwoHourInArrival = 0;
    if (
      this.props.search.searchParams.stophour &&
      !this.props.search.searchParams.token
    ) {
      let stopHourToArrival = 0;
      let connectDate = "";
      let startTripArrivalTime = "";
      if (
        dropofflistnew &&
        dropofflistnew.length > 0 &&
        dropofflistnew[0].DropoffTime
      ) {
        stopHourToArrival = moment(dropofflistnew[0].DropoffTime)
          .add(
            parseInt(this.props.search.searchParams.stophour),
            "hours"
          )
          .format("YYYY-MM-DDTHH:mm:ss");
        connectDate = moment(dropofflistnew[0].DropoffTime).format(
          "DD-MM-YYYY"
        );
        startTripArrivalTime = moment(dropofflistnew[0].DropoffTime).format("YYYY-MM-DDTHH:mm:ss");
      } else {
        stopHourToArrival = moment(el.ArrivalTime)
          .add(
            parseInt(this.props.search.searchParams.stophour),
            "hours"
          )
          .format("YYYY-MM-DDTHH:mm:ss");
        connectDate = moment(el.ArrivalTime).format("DD-MM-YYYY");
        startTripArrivalTime = moment(el.ArrivalTime).format("YYYY-MM-DDTHH:mm:ss");
      }
      window.sessionStorage.setItem(
        "addStophour",
        JSON.stringify(stopHourToArrival)
      );
      window.sessionStorage.setItem(
        "startTripArrivalTime",
        JSON.stringify(startTripArrivalTime)
      );
    }

    if (!this.props.search.searchParams.token && !this.props.search.searchParams.stophour) {
      addTwoHourInArrival = moment(el.ArrivalTime)
        .add(2, "hours")
        .format("YYYY-MM-DDTHH:mm:ss");
      window.sessionStorage.setItem(
        "addTwoHoursInArrival",
        JSON.stringify(addTwoHourInArrival)
      );
    }

    if (!this.props.search.stChrtOthrDtls[rsid]) {
      const url = window.cdnUrl + apiUrl.routeInfo + "?routeID=" + rsid;
      fetchGet(url)
        .then((data) => {
          store.dispatch(updateSeatChartDet(rsid, data));
        })
        .catch((err) => console.log(err));
    }
    store.dispatch(updateSeatChart(rsid, true));
    store.dispatch(updateBusServiceType(el.ServiceType));
    store.dispatch(updateTripCode(el.TripCode));
    if (this.props.search.searchParams.token) {
      let localOnData = JSON.parse(localStorage.getItem('tripData'));
      if (localOnData) {
        tripData.onward.busServiceType = localOnData.onward.busServiceType;
        tripData.onward.tripCode = localOnData.onward.tripCode;
      }
      tripData.return.busServiceType = el.ServiceType;
      tripData.return.tripCode = el.TripCode;
    } else {
      tripData.onward.busServiceType = el.ServiceType;
      tripData.onward.tripCode = el.TripCode;
    }

    localStorage.setItem("tripData", JSON.stringify(tripData));

  };

  animateSeat = () => {
    delayCounter = 0;
    tempScroll = currScrollPos / repetitions;
    // tempScroll = currScrollPos;
    this.moveSeat();
  };

  moveSeat = () => {
    let scrollY = window.scrollY + tempScroll;
    window.scrollTo(0, scrollY);
    if (delayCounter !== repetitions) {
      delayCounter++;
      // setTimeout(this.moveSeat, delay);
      window.scrollTo(0, prevScrollTop + currScrollPos);
    } else {
      window.scrollTo(0, prevScrollTop + currScrollPos);
    }
  };

  closeSeatchart = (rsid) => {
    store.dispatch(updateSeatChart(rsid, false));
  };

  openOtherDet = (e, rsid, param) => {
    e.stopPropagation();
    let showDet = {};
    let showLoader = {};
    showDet[rsid] = param;
    this.setState({ showDet });
    this.closeSeatchart(rsid);

    if (!this.props.search.stChrtOthrDtls[rsid]) {
      const url = window.cdnUrl + apiUrl.routeInfo + "?routeID=" + rsid;
      //store.dispatch(updateLoader(true));
      showLoader[rsid] = true;
      this.setState({ showLoader })
      fetchGet(url)
        .then((data) => {
          store.dispatch(updateSeatChartDet(rsid, data));
          //store.dispatch(updateLoader(false));
          showLoader[rsid] = false;
          this.setState({ showLoader })
        })
        .catch((err) => {
          console.log(err);
          this.setState({ showLoader: {} })
        }
        );
    } else {
      if (this.state.showDet[rsid] === param) {
        this.setState({ showDet: {} });
      } else this.setState({ showDet });
    }
  };

  openAmenitiesDet = (e, rsid, param) => {
    e.stopPropagation();
    let showDet = {};
    showDet[rsid] = param;
    this.setState({ showDet });
    this.closeSeatchart(rsid);
    if (this.state.showDet[rsid] === param) {
      this.setState({ showDet: {} });
    } else this.setState({ showDet });
  }
  setpickupdropoff = (rsid) => {
    let showLoader = {};
    if (!this.props.search.stChrtOthrDtls[rsid]) {
      const url = window.cdnUrl + apiUrl.routeInfo + "?routeID=" + rsid;
      // store.dispatch(updateLoader(true));
      showLoader[rsid] = true;
      this.setState({ showLoader })
      fetchGet(url)
        .then((data) => {
          // store.dispatch(updateLoader(false));
          showLoader[rsid] = false;
          this.setState({ showLoader })
          store.dispatch(updateSeatChartDet(rsid, data));
        })
        .catch((err) => {
          console.log(err)
          this.setState({ showLoader: {} })
        });
    }
  };

  openBusImage = (e, rsid, param) => {
    e.stopPropagation();
    let showDet = {};
    let showLoader = {};
    showDet[rsid] = param;
    this.setState({ showDet });
    this.closeSeatchart(rsid);
    if (!this.props.search.busImgDtls[rsid]) {
      const url = window.url + apiUrl.getBusImage + "?routeCode=" + rsid;
      showLoader[rsid] = true;
      this.setState({ showLoader })
      fetchGet(url)
        .then((data) => {
          let img = Object.values(data);
          if (img && img.length > 0) {
            img = img.filter(el => (el && typeof el == 'string' && el.endsWith('jpg') || el && typeof el == 'string' && el.endsWith('JPG')))
            store.dispatch(updateBusImage(rsid, img));
          } else {
            store.dispatch(updateBusImage(rsid, []));
          }
          showLoader[rsid] = false;
          this.setState({ showLoader })
        })
        .catch((err) => {
          console.log(err);
          this.setState({ showLoader: {} })
        }
        );
    } else {
      if (this.state.showDet[rsid] === param) {
        this.setState({ showDet: {} });
      } else this.setState({ showDet });
    }
  }
  setTripDetail = (rsid, tripId, chartdt) => {
    let showLoader = {};
    if (!this.props.search.tripDetails[rsid]) {
      const url =
        window.cdnUrl +
        apiUrl.tripSummaryPKpDrp +
        "?tripId=" +
        tripId +
        "&chartDate=" +
        chartdt;
      //store.dispatch(updateLoader(true));
      showLoader[rsid] = true;
      this.setState({ showLoader })
      fetchGet(url)
        .then((data) => {
          // store.dispatch(updateLoader(false));
          showLoader[rsid] = false;
          this.setState({ showLoader })
          store.dispatch(updateTripDetail(rsid, data));
        })
        .catch((err) => {
          console.log(err)
          showLoader[rsid] = false;
        }
        );
    }
  };
  showDiscountTag = (val) => {
    if (val.DiscountPer > 0) {
      return (
        <span className="flex-all-c opdiscount">
          {val.DiscountPer}% Off
        </span>
      );
    }
    if (val.DiscountAmt > 0) {
      return (
        <span className="flex-all-c opdiscount">
          <span style={{ fontFamily: "sans-serif" }}>
            {this.props.search.currency}
          </span>
          {val.DiscountAmt} Off
        </span>
      );
    }
  };

  roundtripDiscountTag = (val) => {
    if (val.RoundTripDiscountPer > 0) {
      return (
        <div className="round-discount">
          +{val.RoundTripDiscountPer}% {t(EXT_OFF_RND_TP)}
        </div>
      );
    } else if (val.RoundTripDiscountAmt > 0) {
      return (
        <div className="round-discount">
          {t(RND_TP_DISC)}{" "}
          <span style={{ fontFamily: "sans-serif" }}>
            {this.props.search.currency}
          </span>
          {val.RoundTripDiscountAmt}
        </div>
      );
    }
  };

  redirectToGPS = (val) => {
    return <Trackbus route={val} />;
  };

  goToPath = (routecode, e, param) => {
    e.stopPropagation();
    if (this.props.search.routecodeDtls[routecode]) {
      store.dispatch(updateRouteCodeDtls(routecode, false));
    } else {
      store.dispatch(updateRouteCodeDtls(routecode, true));
    }
  };

  showPath = (routecode) => {
    if (this.props.search.routecodeDtls[routecode]) {
      return <Showpath key={`key${routecode}`} routeCode={routecode} />;
    }

    // return <Showpath key={`key${routecode}`} routeCode={routecode} />;
  };

  handleSlider = (el, open, e) => {
    if (e) e.stopPropagation();
    this.setState({
      showImgSlider: open,
      showImgSliderId: el.RouteScheduleId,
    });
  };

  showServiceRouteDetails = (el, open, e) => {
    e.stopPropagation();
    let tripId = el.TripID;
    let chartDate = el.ChartDate;
    const url =
      window.cdnUrl +
      apiUrl.tripSummaryPKpDrp +
      "?tripId=" +
      tripId +
      "&chartDate=" +
      chartDate;
    // store.dispatch(updateLoader(true));
    let showTripLoader = {};
    showTripLoader[el.RouteScheduleId] = true;
    this.setState({ showTripLoader })
    fetchGet(url)
      .then((data) => {
        let summaryPkpDrop = data;
        this.setState({
          summaryPkpDrop,
          showServiceDtls: open,
          showrouteDtlsId: el.RouteScheduleId,
        });
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        // store.dispatch(updateLoader(false));
        showTripLoader[el.RouteScheduleId] = false;
        this.setState({ showTripLoader })
      })
      .catch((err) => {
        console.log(err);
        // store.dispatch(updateLoader(false));
        showTripLoader[el.RouteScheduleId] = false;
        this.setState({ showTripLoader })
      });
  };

  close = (flag) => {
    this.setState({ showServiceDtls: flag });
  };

  showBusType = (el) => {
    let busType = el.ServiceType ? el.ServiceType : "";
    let serviceType = el.ServiceType;
    if (serviceType) {
      // busType += (el.HasAC ? (serviceType.includes("AC") ? '' : ', AC') : '') +
      //   (el.HasNAC ? (serviceType.includes("Non AC") ? '' : ', Non AC') : '') +
      //   (el.HasSeater ? (serviceType.includes("Seater") ? '' : ', Seater') : '') +
      //   (el.HasSleeper ? (serviceType.includes("Sleeper") ? '' : ', Sleeper') : '') +
      //   (el.BusType ? (serviceType.includes(el.BusType) ? '' : ', ' + el.BusType) : '') +
      //   (el.Arrangement ? (serviceType.includes(el.Arrangement) ? '' : ', ' + el.Arrangement) : '');
      busType = serviceType;
    } else {
      busType =
        (el.HasAC ? "AC, " : "") +
        (el.HasNAC ? " Non AC, " : "") +
        (el.HasSeater ? " Seater, " : "") +
        (el.HasSleeper ? " Sleeper, " : "") +
        (el.BusType ? el.BusType + ", " : " ") +
        (el.Arrangement ? el.Arrangement : "");
    }
    return busType;
  };

  renderBusThumbnill = (el) => {
    let imgType = "";
    const type = el.ServiceType;
    if (type.includes("GAJARAJ") || type.includes("gajraj")) {
      imgType = "Swift-gajraj-thumb";
    } else if (type.includes("GARUDA") || type.includes("garuda")) {
      imgType = "Swift-Garuda-thumb";
    } else if (type.includes("MINNAL") || type.includes("minnal")) {
      imgType = "ksrtc-thumb";
    } else if (
      type.includes("SUPER FAST AIR BUS") ||
      type.includes("super fast air bus")
    ) {
      imgType = "ksrtc-thumb";
    } else if (
      type.includes("SUPER DELUXE AIR BUS") ||
      type.includes("super deluxe air bus")
    ) {
      imgType = "ksrtc-thumb";
    } else if (
      type.includes("SWIFT SUPER FAST AIR BUS") ||
      type.includes("swift super fast air bus")
    ) {
      imgType = "Swift-deluxe-thumb";
    } else if (
      type.includes("LOWER FLOOR AC") ||
      type.includes("lower floor ac")
    ) {
      imgType = "ksrtc-thumb";
    } else if (
      type.includes("AC MULTI AXLE") ||
      type.includes("ac multi axle")
    ) {
      imgType = "ksrtc-thumb";
    } else if (type.includes("HYBRID") || type.includes("hybrid")) {
      imgType = "ksrtc-thumb";
    } else {
      imgType = null;
    }
    return (
      imgType && (
        <div
          className="bus--image"
          key={el.RouteScheduleId + "-img"}
          onClick={(e) => this.handleSlider(el, true, e)}
        >
          {renderImg(imgType)}
        </div>
      )
    );
  };

  boardingPointinSC = (el) => (
    <div
      className={`primarybutton flex-vc ${this.state.showDet[el.RouteScheduleId] === 2 ? "active" : ""
        }`}
      onClick={(event) => this.openOtherDet(event, el.RouteScheduleId, 2)}
    >
      <span className="lspacerite">
        {t(BOARDING_POINTS)}
        {/* {this.showPick(el.RouteScheduleId)} */}
      </span>
      <span
        className={
          this.state.showDet[el.RouteScheduleId] === 2
            ? "arrowplain top sc_card"
            : "arrowplain bottom"
        }
      ></span>
    </div>
  );

  cancPolicySC = (el, rsid, tripid, chartdt) => {
    return el.IsNonRefundable ? (
      <span
        className="primarybutton flex-vc lspacerite"
        style={{
          position: "relative",
        }}
      >
        {t(NON_RFNDBLE)}
      </span>
    ) : (
      <span
        className={`primarybutton flex-vc ${this.state.showDet[el.RouteScheduleId] === 1 ? "active" : ""
          }`}
        style={{
          position: "relative",
        }}
        onClick={(event) => {
          this.openOtherDet(event, el.RouteScheduleId, 1);
          this.setTripDetail(rsid, tripid, chartdt);
        }}
      >
        <span className="lspacerite">{t(CANCELLATION_POLICY)}</span>
        <span
          className={
            this.state.showDet[el.RouteScheduleId] === 1
              ? "arrowplain top sc_card"
              : "arrowplain bottom"
          }
        ></span>
        {/* {this.showPolicy(el.RouteScheduleId)} */}
      </span>
    );
  };

  dropPointsSC = (el) => (
    <div
      className={`primarybutton flex-vc ${this.state.showDet[el.RouteScheduleId] === 3 ? "active" : ""
        }`}
      onClick={(event) => this.openOtherDet(event, el.RouteScheduleId, 3)}
    >
      <span className="lspacerite" style={{ position: "relative" }}>
        {t(DROPPING_POINTS)}
        {/* {this.showDrop(el.RouteScheduleId)} */}
      </span>
      <span
        className={
          this.state.showDet[el.RouteScheduleId] === 3
            ? "arrowplain top sc_card"
            : "arrowplain bottom"
        }
      ></span>
    </div>
  );

  viaCitiesSc = (el) => (
    <div
      className={`primarybutton flex-vc ${this.state.showDet[el.RouteScheduleId] === 4 ? "active" : ""
        }`}
      onClick={(event) => {
        this.openOtherDet(event, el.RouteScheduleId, 4);
      }}
    >
      <span className="lspacerite">{t(VIA_CITIES)}</span>
      <span
        className={
          this.state.showDet[el.RouteScheduleId] === 4
            ? "arrowplain top sc_card"
            : "arrowplain bottom"
        }
      ></span>
    </div>
  );

  amenitiesSC = (el) => (
    <div
      className={`primarybutton flex-vc ${this.state.showDet[el.RouteScheduleId] === 5 ? "active" : ""
        }`}
      onClick={(event) => {
        this.openAmenitiesDet(event, el.RouteScheduleId, 5);
        // this.openOtherDet(event, el.RouteScheduleId, 5);
      }}
    >
      <span className="lspacerite">{t(AMENITIES)}</span>
      <span
        className={
          this.state.showDet[el.RouteScheduleId] === 5
            ? "arrowplain top sc_card"
            : "arrowplain bottom"
        }
      ></span>
    </div>
  );

  busPicturesSC = (el) => (
    <div
      className={`primarybutton flex-vc ${this.state.showDet[el.RouteScheduleId] === 6 ? "active" : ""
        }`}
      onClick={(event) => {
        this.openBusImage(event, el.RouteScheduleId, 6);
      }}
    >
      <span className="lspacerite">{t(BUS_PICTURES)}</span>
      <span
        className={
          this.state.showDet[el.RouteScheduleId] === 6
            ? "arrowplain top sc_card"
            : "arrowplain bottom"
        }
      ></span>
    </div>
  );

  selectSeatsSC = (el, tripStarted, dropofflistnew) => (
    <div
      className="selectbutton"
      /* onClick={(event) =>
        this.props.search.stChrtStatus[el.RouteScheduleId]
          ? this.closeSeatchart(el.RouteScheduleId)
          : this.openSeatchart(
            event,
            el.RouteScheduleId,
            el,
            dropofflistnew
          )
      } */
      style={{
        fontSize: "0.75em",
        border: "1px solid",
        borderColor: tripStarted
          ? "#ddd"
          : el.IsReservable === 0
            ? "#ddd"
            : el.AvailableSeats > 0
              ? "var(--ksrtcThColor2)"
              : "#ddd",
        background: !this.props.search.stChrtStatus[el.RouteScheduleId]
          ? tripStarted
            ? "#ddd"
            : el.IsReservable === 0
              ? "#ddd"
              : el.AvailableSeats > 0
                ? "var(--ksrtcThColor2)"
                : "#ddd"
          : "#fff",
        color: !this.props.search.stChrtStatus[el.RouteScheduleId]
          ? "#fff"
          : tripStarted
            ? "#ddd"
            : el.IsReservable === 0
              ? "#ddd"
              : "var(--ksrtcThColor2)",
        pointerEvents: tripStarted
          ? "none"
          : el.IsReservable === 0
            ? "none"
            : el.AvailableSeats > 0
              ? "all"
              : "none",
      }}
    >
      {this.props.search.stChrtStatus[el.RouteScheduleId]
        ? t(CLOSE_CHART)
        : el.AvailableSeats > 0
          ? el.HasSleeper
            ? t(SELECT_BERTH)
            : t(SELECT_SEATS)
          : t(SOLD_OUT)}
    </div>
  );

  render() {

    let loop = this.props.search.returnBuses;

    // console.log("hhh", this.props.search.pathDtls)
    const urlParams = new URLSearchParams(window.location.search);
    const linkfromCityId = urlParams.get("linkfromCity");
    const linktoCityId = urlParams.get("linktoCity");
    const stationInFromCityKey = urlParams.get("stationInFromCity");
    const stationInToCityKey = urlParams.get("stationInToCity");
    const stationInFromCity =
      stationInFromCityKey &&
      stationInFromCityKey.split("|")[1].split(",");
    const stationInToCity =
      stationInToCityKey && stationInToCityKey.split("|")[1].split(",");
    const stophourVal = JSON.parse(sessionStorage.getItem("addStophour"));
    const addTwoHoursInArrival = JSON.parse(sessionStorage.getItem("addTwoHoursInArrival"));
    // const stationInFromCity = stationInFromCityKey && stationInFromCityKey.split("|")[0].replace(/[^a-zA-Z]/g, " ");
    // const stationInToCity = stationInToCityKey && stationInToCityKey.split("|")[0].replace(/[^a-zA-Z]/g, " ");

    if (addTwoHoursInArrival && this.props.search.searchParams.token && !this.props.search.searchParams.linkfromstoptocity) {
      loop =
        (loop &&
          loop.length > 0 &&
          loop.filter(
            (el) =>
              new Date(el.DepartureTime).getTime() >=
              new Date(addTwoHoursInArrival).getTime()
          )) ||
        [];
    }

    if (this.props.search.searchParams.token && this.props.search.searchParams.linkfromstoptocity) {

      const startTripArrivalTime = JSON.parse(sessionStorage.getItem("startTripArrivalTime"));
      const deptStartFrom = moment(startTripArrivalTime).add(1, "hours").format("YYYY-MM-DDTHH:mm:ss");
      const deptEndTo = moment(startTripArrivalTime).add(24, "hours").format("YYYY-MM-DDTHH:mm:ss");

      const startTime = new Date(deptStartFrom).getTime();
      const endTime = new Date(deptEndTo).getTime();

      loop =
        (loop &&
          loop.length > 0 &&
          loop.filter( (el) => {
            const dt = new Date(el.DepartureTime).getTime();
            return (dt >= startTime && dt <= endTime)
          })) || [];
    }

    if (loop.length > 0) {

      return loop.map((el) => {

        // const linkroutecheck = urlParams.get("link");
        var Fromfilterlink = true;
        var Tofilterlink = true;
        var pickuplistnew = [];
        var dropofflistnew = [];
        var fromFilterStation = true;
        var tofilterStation = true;
        var stophourFilter = true;
        // var roundTripCardFilter = true;

        if (linkfromCityId) {
          const pickkdropuplist =
            this.props.search.stChrtOthrDtls[el.RouteScheduleId];
          // var toSearch = "amaravati";
          if (pickkdropuplist !== undefined) {
            const pickuplist = pickkdropuplist.pickups;
            var key;

            Fromfilterlink = false;
            for (key in pickuplist) {
              if (
                pickuplist[key].PickupLinkCityId ===
                parseInt(linkfromCityId)
              ) {
                pickuplistnew.push(pickuplist[key]);
                Fromfilterlink = true;
              }
            }
          }
        }

        if (linktoCityId) {
          const pickkdropuplist =
            this.props.search.stChrtOthrDtls[el.RouteScheduleId];
          // var toSearch = "amaravati";
          if (pickkdropuplist !== undefined) {
            const pickuplist = pickkdropuplist.dropPoints;
            var key;
            Tofilterlink = false;
            for (key in pickuplist) {
              if (
                pickuplist[key].DropLinkCityID ===
                parseInt(linktoCityId)
              ) {
                dropofflistnew.push(pickuplist[key]);
                Tofilterlink = true;
              }
            }
          }
        }

        // filter stations through pickid
        if (stationInFromCity && stationInFromCity.length > 0) {
          const pickkdropuplist =
            this.props.search.stChrtOthrDtls[el.RouteScheduleId];
          if (pickkdropuplist !== undefined) {
            const pickuplist = pickkdropuplist.pickups;
            var key;

            fromFilterStation = false;
            for (key in pickuplist) {
              if (
                stationInFromCity.includes(
                  String(pickuplist[key].PickupID)
                )
              ) {
                pickuplistnew.push(...pickuplist);
                pickuplistnew.unshift(pickuplist[key]);
                pickuplistnew = [...new Set(pickuplistnew)];
                fromFilterStation = true;
              }
            }
          }
        }

        //filter through dropId
        if (stationInToCity && stationInToCity.length > 0) {
          const pickkdropuplist =
            this.props.search.stChrtOthrDtls[el.RouteScheduleId];
          if (pickkdropuplist !== undefined) {
            const pickuplist = pickkdropuplist.dropPoints;
            var key;
            tofilterStation = false;
            for (key in pickuplist) {
              if (
                stationInToCity.includes(
                  String(pickuplist[key].DropoffID)
                )
              ) {
                dropofflistnew.push(...pickuplist);
                dropofflistnew.unshift(pickuplist[key]);
                dropofflistnew = [...new Set(dropofflistnew)];
                tofilterStation = true;
              }
            }
          }
        }

        /* if (this.props.search.searchParams.token && this.props.search.searchParams.linkfromstoptocity) {
          stophourFilter = false;
          if (new Date(el.DepartureTime).getTime() >= new Date(stophourVal).getTime()) {
            stophourFilter = true;
          }
        } */

        // if (this.props.search.searchParams.token && !this.props.search.searchParams.linkfromstoptocity) {
        //   roundTripCardFilter = false;
        //   if ((new Date(el.DepartureTime).getTime()) >= (new Date(addTwoHoursInArrival).getTime())) {
        //     roundTripCardFilter = true;
        //   }
        // }

        if (
          (Fromfilterlink || Tofilterlink) &&
          fromFilterStation &&
          tofilterStation &&
          stophourFilter
        ) {
          let rsid = el.RouteScheduleId;
          let tripid = el.TripID;
          let chartdt = el.ChartDate;
          // this.setpickupdropoff(rsid);
          // this.setTripDetail(rsid, tripid, chartdt);
          const disFare =
            el.DiscountPer > 0 || el.DiscountAmt > 0 ? true : false;
          const disrountfare =
            el.IsRoundTripDiscount &&
            this.props.search.searchParams.mode === "roundtrip";
          const pickdroplist = this.props.search.stChrtOthrDtls[rsid]
            ? this.props.search.stChrtOthrDtls[rsid]
            : false;
          let firstpickup, pickupcount, firstdropoff, dropoffcount;
          if (pickdroplist) {
            if (pickuplistnew && pickuplistnew.length > 0) {
              firstpickup = pickuplistnew[0].PickupName;
            } else {
              firstpickup =
                pickdroplist.pickups.length > 0
                  ? pickdroplist.pickups[0].PickupName
                  : "";
            }
            pickupcount = pickuplistnew.length
              ? pickuplistnew.length
              : pickdroplist.pickups.length;
            if (dropofflistnew && dropofflistnew.length > 0) {
              firstdropoff = dropofflistnew[0].DropoffName;
            } else {
              firstdropoff =
                pickdroplist.dropPoints.length > 0
                  ? pickdroplist.dropPoints[0].DropoffName
                  : "";
            }
            dropoffcount = dropofflistnew.length
              ? dropofflistnew.length
              : pickdroplist.dropPoints.length;
          }

          let tripStarted = false;

          if (
            this.props.search.seatChartErrorMsg[rsid] ===
            "No more Bookings Can be performed on this Trip,Bus is already locked"
          ) {
            tripStarted = true;
          }
          // const tripDetails = this.props.search.tripDetails[rsid] ? this.props.search.tripDetails[rsid] : false;
          // if (tripDetails) {
          //   let tripStartTime = tripDetails.PickupTimings;
          //   tripStartTime = tripStartTime.sort((a, b) => new Date(a.PickupTime) - new Date(b.PickupTime));
          //   let tStartTime = new Date(tripStartTime[0].PickupTime);
          //   tStartTime.setHours(tStartTime.getHours() - 1);
          //   if (tStartTime.getTime() < new Date().getTime()) {
          //     tripStarted = true;
          //   } else {
          //     tripStarted = false;
          //   }
          // }

          let covidamencount =
            el.Covid19Amenities && el.Covid19Amenities.length > 0
              ? el.Covid19Amenities.split(",").length
              : 0;
          if (covidamencount > 0) {
            el.Covid19Config = 1;
          }

          //el.IsReservable = 1;
          //el.IsSpecial = 0;
          

          return (
            <React.Fragment key={"RF-" + el.RouteScheduleId}>
              <div
                key={el.RouteScheduleId}
                className={
                  this.state.seoChartactive &&
                    this.props.search.stChrtStatus[
                    el.RouteScheduleId
                    ]
                    ? "srch-card active"
                    : el.IsSpecial
                      ? "srch-card is--special"
                      : "srch-card"
                }
              >
                <div className="listinng-block">
                  <div className="listinng-block-left">
                  {
                    el.SlackPer > 0 && <div className="srch-card-first-row">
                      {/* <div className="covid-row">
                        {el.Covid19Config && (
                          <div className="safebus">
                            {t(SAFE_BUS)}
                          </div>
                        )}
                        {this.showCovidAmenities(
                          el.Covid19Config,
                          el.Covid19Amenities
                        )}
                      </div> */}
                     {/* <div className="discount-tag">{el.SlackPer}% OFF</div> */}
                    </div>
                    }
                    <div className="srch-card-row" style={{ justifyContent: 'flex-start' }}>
                      <div
                        className="srch"
                        style={{ width: "35%" }}
                      >
                        {this.state.showTripLoader[el.RouteScheduleId] && (
                          <div className="loading">
                            <span></span>
                            <span></span>
                            <span></span>
                          </div>
                        )}
                        <div
                          className=""
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            textDecoration: "underline",
                            textDecorationColor: "var(--ksrtcThColor2)",
                          }}
                          onClick={(e) => {
                            this.showServiceRouteDetails(el, true, e)
                          }}
                        >
                          {/* {el.CompanyName.toUpperCase()}
                        {el.TripCode && ' - '} */}
                          {el.TripCode && (
                            <span className="service--route sc">
                              {el.TripCode}
                            </span>
                          )}
                          {/* renderImg("trip_icon") */}
                          <SRPTripIcon fillcolor={'var(--ksrtcThColor2)'} />
                          {/* {el.Suffix ? " - " + el.Suffix.toUpperCase() : ""} */}
                        </div>
                      </div>
                      <div
                        className="srch"
                        style={{ width: "50%" }}
                      >
                        <div className="bus--type">
                          {this.showBusType(el)}
                        </div>
                      </div>
                      {el.IsSpecial ? <div className="srch">
                        <div className="bus--type" style={{ color: 'red' }}>
                          {t(SPL_B)}
                        </div>
                      </div>
                        : ""
                      }
                      {el.IsReservable == 0 ? <div className="srch">
                        <div className="bus--type" style={{ color: 'red' }}>
                          {t(NON_RSRVBLE)}
                        </div>
                      </div>
                        : ""
                      }
                      <div
                        style={{
                          width: "15%",
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        {this.showDiscount(el)}
                      </div>
                    </div>
                    <div className="srch-card-row">
                      <div
                        className="srch"
                        style={{ width: "20%", fontSize: "0.875em" }}
                      >
                        {t(STARTS_AT)}
                      </div>
                      <div
                        className="srch"
                        style={{ width: "15%", fontSize: "0.875em" }}
                      >
                        {t(DURATION)}
                      </div>
                      <div
                        className="srch"
                        style={{ width: "28%", fontSize: "0.875em" }}
                      >
                        {t(REACHES_ON)}
                      </div>
                      <div
                        className="srch"
                        style={{ width: "23%", fontSize: "0.875em" }}
                      >
                        {t(VIA)}
                      </div>
                      {/* <div
                        style={{
                          width: "15%",
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        {this.showDiscount(el)}
                      </div> */}
                      <div className="srch tl_right" style={{ width: '15%', fontSize: "0.875em", color: '#444' }}>
                        {t(AVAILABLE)}
                      </div>
                    </div>
                    <div className="srch-card-row">
                      <div
                        style={{
                          width: "20%",
                          paddingRight: "10px",
                        }}
                      >
                        <div className="triptimebold darkText1">
                          {pickuplistnew &&
                            pickuplistnew.length > 0
                            ? get24HoursTime(
                              pickuplistnew[0]
                                .PickupTime
                            )
                            : getFormattedTime(
                              el.DepartureTime
                            )}
                          {/* {", "}
                          {pickuplistnew &&
                            pickuplistnew.length > 0
                            ? getFormattedDayDate(
                              pickuplistnew[0]
                                .PickupTime
                            )
                            : getFormattedDayDate(
                              el.DepartureTime
                            )} */}
                          {", "}
                          {this.state.fromCity}
                        </div>
                      </div>
                      <div
                        style={{
                          width: "15%",
                          paddingRight: "10px",
                        }}
                      >
                        <div className="duration darkText1">
                          {/* <span className="circlegreen"></span> */}
                          <span
                            style={{ marginTop: "1px" }}
                          >
                            <img
                              src={getImgPath(
                                "/img/triangle.png"
                              )}
                            />
                          </span>
                          <span
                            className="linespacefill"
                            style={{
                              background: "#4FBA99",
                            }}
                          ></span>
                          <div className="lightText fw-500">
                            {getDur(
                              el.DepartureTime,
                              el.ArrivalTime
                            )}
                          </div>
                          <span
                            className="linespacefill"
                            style={{
                              background: "#E72A01",
                            }}
                          ></span>
                          <span
                            className="squarered"
                            style={{
                              background: "#E72A01",
                            }}
                          ></span>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "28%",
                          paddingRight: "10px",
                        }}
                      >
                        <div className="triptimebold darkText1">
                          <span style={{ fontSize: '0.7em' }}>{dropofflistnew &&
                            dropofflistnew.length > 0
                            ? getFormattedDayDate(
                              dropofflistnew[0]
                                .DropoffTime
                            )
                            : getFormattedDayDate(
                              el.ArrivalTime
                            )}
                          </span>
                          {", "}
                          {dropofflistnew &&
                            dropofflistnew.length > 0
                            ? get24HoursTime(
                              dropofflistnew[0]
                                .DropoffTime
                            )
                            : getFormattedTime(
                              el.ArrivalTime
                            )}
                          {", "}
                          {this.state.toCity}
                        </div>
                      </div>
                      <div
                        style={{
                          width: "23%",
                          paddingRight: "10px",
                          fontSize: '0.875em'
                        }}
                        className="triptimebold darkText1"
                      >
                        {" "}
                        {el.ViaPlaces}
                      </div>
                      <div
                        className="srch tl_right"
                        style={{ width: "15%", fontSize: '1.125em', fontWeight: '500', color: '#202020' }}
                      >
                        {el.AvailableSeats}{" "}{`Seat${el.AvailableSeats > 1 ? "s" : ""}`}
                      </div>
                    </div>
                    <div
                      className="srch-card-row"
                      style={{
                        justifyContent: "space-between",
                      }}
                    >
                      <div className="srch">
                        {this.boardingPointinSC(el)}
                      </div>
                      <div className="srch">
                        {this.cancPolicySC(
                          el,
                          rsid,
                          tripid,
                          chartdt
                        )}
                      </div>
                      <div className="srch">
                        {this.dropPointsSC(el)}
                      </div>
                      <div className="srch">
                        {this.viaCitiesSc(el)}
                      </div>
                      <div className="srch">
                        {this.amenitiesSC(el)}
                      </div>
                      <div className="srch">
                        {this.busPicturesSC(el)}
                      </div>
                      {/* <div>
                        {this.selectSeatsSC(
                          el,
                          tripStarted,
                          dropofflistnew
                        )}
                      </div> */}
                    </div>
                  </div>
                </div>

                {this.state.showLoader[el.RouteScheduleId] && (
                  <div className="loading">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                )}

                {/* <div className="optionalslider">
                  {this.props.search.stChrtStatus[el.RouteScheduleId]
                    ? ""
                    : SliderScroll(imgarray)}
                </div> */}
                {/* {this.state.showImgSlider &&
                  el.RouteScheduleId ===
                  this.state.showImgSliderId && (
                    <div>
                      {
                        <ImageSlider
                          handleSlider={this.handleSlider}
                          busSeriveType={el.ServiceType}
                        />
                      }
                    </div>
                  )} */}
                {this.state.showServiceDtls &&
                  el.RouteScheduleId ===
                  this.state.showrouteDtlsId && (
                    <div>
                      <ServiceRouteDtls
                        data={el}
                        summaryData={
                          this.state.summaryPkpDrop
                        }
                        close={() => this.close(false)}
                      />
                    </div>
                  )}
                {this.showSeatchart(el)}
              </div>
            </React.Fragment>

          );
        } else {
          return "";
        }
      });
    } else if (loop.length === 0) {
      if (this.props.search.searchParams.token) {
        let errmsg = this.state.showErrMsg;
        return (
          <div>
            {errmsg ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#e72a01",
                  fontWeight: "500",
                  marginTop: "100px",
                }}
              >
                {t(NO_RESLTS_FND)}
              </div>
            ) : (
              ""
            )}
          </div>
        );
      } else if (this.props.search.data.length > 0) {
        return (
          <div className="filtererrorsec">
            <img
              src={getImgPath("/img/filter-error.png")}
              alt="mantis logo"
              style={{ marginLeft: "7px" }}
            />
            <span>
              We’re sorry that there are no buses available as per
              “your filter”
              <br /> but buses may be available if filters are
              removed.
            </span>
            <button
              className="flex-all-c resetfilterbutton"
              onClick={() => {
                store.dispatch(updateFilterReset());
              }}
            >
              {t(REMOVE_FILTER)}
            </button>
          </div>
        );
      } else {
        return (
          <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#e72a01",
                  fontWeight: "500",
                  marginTop: "100px",
                }}
              >
                {t(NO_RESLTS_FND)}
              </div>
          </div>
        );
      }
    //} //else if (loop.length === 0) {
      //if (this.props.search.data.length > 0) {
        // return (
        //   <div className="filtererrorsec">
        //     <img
        //       src={getImgPath("/img/filter-error.png")}
        //       alt="mantis logo"
        //       style={{ marginLeft: "7px" }}
        //     />
        //     <span>
        //       We’re sorry that there are no buses available as per
        //       “your filter”
        //       <br /> but buses may be available if filters are
        //       removed.
        //     </span>
        //     <button
        //       className="flex-all-c resetfilterbutton"
        //       onClick={() => {
        //         store.dispatch(updateFilterReset());
        //       }}
        //     >
        //       Remove Filter
        //     </button>
        //   </div>
        // );
      //} else {
        //return (
          // <div className='loading'>
          // {/* Loading... */}
          //     <span></span>
          //     <span></span>
          //     <span></span>
          // </div>
          //""
        //);
      //}
    } else {
      return (
        <div className="filtererrorsec"
          style=
          {{
            display: 'flex',
            margin: '15px 30px',
            borderRadius: '10px'
          }}>
          <div style={{ background: '#fff',padding:'24px' }}>
            {/* <div>
              <img
                // src={getImgPath("/img/route-error.png")}
                src={getImgPath("/img/no-buses-found.png")}
                alt="mantis logo"
                style={{}}
              />
            </div> */}
            <div style={{ color: '#1a1a1a', fontWeight: '400', fontSize: '1.5em', lineHeight: '1.920em', marginTop: '0px', textAlign: 'center'}}>
              {
                this.state.isAdvanceBooking ?
                  tCommon(ADVANCE_BOOKING) :
                  <>
                    {tCommon(RESULT_NOT_FOUND)}{" "}<br />
                    <span style={{ color: '#1a1a1a', fontWeight: '600', margin: '0' }}>{"'"}{this.props.search.searchParams.toCity.split("|")[1]} {tCommon(TO)}{" "}
                      {this.props.search.searchParams.fromCity.split("|")[1]}{"'"}</span><br />
                    {tCommon(PLEASE_MODIFY_SEARCH)}{" "}{this.props.search.linkedCityData && this.props.search.linkedCityData.length > 0 && tCommon(OR)}
                      {this.props.search.linkedCityData && this.props.search.linkedCityData.length > 0 && this.props.search.searchParams.mode!='roundtrip' && !this.props.search.searchParams.linkfromstoptocity && !this.props.search.searchParams.token && 
                        <div className="connect-bus-button-wrap">
                          <div className="btnConnectBus" onClick={() => this.props.handleConnectBusOption()}>{tCommon(CONNECT_BUS_OPTION)}</div>
                        </div>
                      }    
                  </>
              }
            </div>
          </div>
        </div>
      );
      // return <WaitList data={this.props.search.searchParams} />;

    }
  }
}

const mapStateToProps = function (store) {
  return store;
};

export default connect(mapStateToProps)(ReturnListing);
